import { render, staticRenderFns } from "./image-link-button.vue?vue&type=template&id=145d0780&scoped=true&"
import script from "./image-link-button.vue?vue&type=script&lang=ts&"
export * from "./image-link-button.vue?vue&type=script&lang=ts&"
import style0 from "./image-link-button.vue?vue&type=style&index=0&id=145d0780&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145d0780",
  null
  
)

export default component.exports